export default __webpack_public_path__ + "static/media/Group1744.458d3c65.svg";